<template>
<div id="year-2020-double-11" class="year-2020-double-11" >
    <div ref="main" class="content">
        <div class="banner">
            <img :src="pictures.banner" alt="掌门少儿">
            <button @click="toggleDialogForm('双11落地页免费领取', '2')"></button>
        </div>
        <div class="children">
            <v-lazy-image :src="pictures.children"/>
        </div>
        <div class="course-intro"  v-swiper:mySwiper="swiperOption">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in introList" :key="'intro' + index">
                    <v-lazy-image :src="item" />
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
        <div class="course-advance">
            <v-lazy-image :src="pictures.course"/>
        </div>
        <div class="teacher-intro">
            <v-lazy-image :src="pictures.teacher"/>
        </div>

        <div class="dialog-form" v-if="showDialogForm">
            <div class="lesson-form-content"  ref="lessonFormContent">
                <div class="lesson-form-box">
                    <lesson-form btnText="立即领取" :hasBottom="false" TitleText :btnType="btnType" comeFrom="kid-m" type="homePage" :homepageWeekSubject="homepageWeekSubject" :trigger_site="trigger_site" @showSuccessDialog="showSuccessDialog" :index_form_showmsg="index_form_showmsg"></lesson-form>
                    <img class="dialog-form-close" src="https://web-data.zmlearn.com/image/pMeJFjz6QKFohpr9b4wPSH/icon_close.png" @click="toggleDialogForm('双11落地页立即领取', '3')" />
                </div>
            </div>
        </div>
        <!-- 成功弹窗 -->
        <success-dialog ref="successDialog"></success-dialog>
        <kid-success-dialog ref="kidSuccessDialog"></kid-success-dialog>
    </div>
    <div  ref='fixedBottom' :class="['get-course', fixedBottom ? 'fixed-bottom' : '']" @click="toggleDialogForm('双11落地页立即领取', '3')">
        <v-lazy-image :src="pictures.fixBottom" alt="点击领取双11专属礼包"/>
    </div>
</div>
</template>

<script>
import lessonForm from "./lesson-form";
import successDialog from "@/components/success-dialog/success-dialog";
import kidSuccessDialog from "@/components/kid-success-dialog/kid-success-dialog";

import VLazyImage from "v-lazy-image";

const FROM_DICT = [{
    "1": {
        trigger_site: "进入双11少儿渠道注册落地页",
        event_id: "enter_kid_act08_homepage",
        event_name: "进入|少儿|注册落地页|官网主页面",
        position: "进入页面",
    },
    "2": {
        trigger_site: "免费领取",
        event_id: "click_kid_act08_mflq",
        event_name: "点击|少儿|注册落地页|免费领取",
        position: "免费领取",
    },
    "3": {
        trigger_site: "立即领取",
        event_id: "click_kid_act08_ljlq",
        event_name: "点击|少儿|注册落地页|立即领取",
        position: "立即领取",
    },
    "4": {
        trigger_site: "注册落地页领取弹窗中立即领取",
        event_id: "click_kid_act08_ljlq02",
        event_name: "点击|少儿|官网m端|预约试听",
        position: "注册落地页领取弹窗中立即领取",
    },
    "5": {
        trigger_site: "领取试听课成功",
        event_id: "enter_kid_act08_success",
        event_name: "进入|少儿|注册落地页|领取成功",
        position: "领取试听课成功",
    },
}, ];

export default {
    name: "home",
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            ZMSDK.onEvent("进入页面", "少儿m站", {
                bu: "2",
                channel_id: vm.$route.query.channel_code,
            });
        });
    },
    components: {
        lessonForm,
        kidSuccessDialog,
        successDialog,
        VLazyImage
    },
    data() {
        return {
            index_form_showmsg: "预约登记后会有课程顾问与您电话联系",
            showDialog: false,
            showDialogForm: false,
            showBottomBtn: false,
            formPopType: 1,
            homepageWeekSubject: '数理逻辑训练',
            swiperOption: {
                //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                preventClicks: false,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                direction: 'horizontal',
                freeMode: false,
                // loop: true,
                observer: true,
                observeParents: true
            },
            introList: [
                'https://web-data.zmlearn.com/image/4Vbdiimhp2rwU1QAVoYDd4/003-1.png',
                'https://web-data.zmlearn.com/image/nyVALVnmxwdcwQed3Qipdt/003-2.png'
            ],
            pictures: {
                banner: 'https://web-data.zmlearn.com/image/49vXYHaKmHU3znbne3ue5o/001.png',
                children: 'https://web-data.zmlearn.com/image/rRA5iQ1etSocW9vdPVoAZz/002.png',
                teacher: 'https://web-data.zmlearn.com/image/jjNdXdCRexmkcycSqtNFqm/005.png',
                course: 'https://web-data.zmlearn.com/image/o5yUfJkYtEmezNhYNBHSxo/004.png',
                fixBottom: 'https://web-data.zmlearn.com/image/bwqrpi9u6KNzixqEapDb6y/botto.png'
            },
            fixedBottom: false
        };
    },
    created() {},
    mounted() {
        this.$nextTick(() => {
            window.addEventListener("scroll", this.checkPosition, false);
            this.checkPosition();
            ZM_JSSDK &&
                ZM_JSSDK.sendEvent({
                    eventId: FROM_DICT[0][1].event_id,
                    eventParam: {
                        name: FROM_DICT[0][1].event_name,
                    },
                });
        });
    },
    destroyed() {
        window.removeEventListener("scroll", this.checkPosition);
    },
    methods: {
        toggleDialogForm(type, from) {
            this.btnType = type;
            this.showDialogForm = !this.showDialogForm;
            this.trigger_site = FROM_DICT[0][from].trigger_site;
            ZM_JSSDK &&
                ZM_JSSDK.sendEvent({
                    eventId: FROM_DICT[0][from].event_id,
                    eventParam: {
                        name: FROM_DICT[0][from].event_name,
                        position: FROM_DICT[0][from].position,
                        order_site: this.trigger_site,
                    },
                });
        },
        checkPosition() {
            const screenHeight = window.screen.availHeight;
            const scrollY = window.scrollY;
            const footerBottomY = this.$refs.main.clientHeight - screenHeight;
            this.fixedBottom = scrollY > screenHeight && scrollY < footerBottomY ;
        },
        showSuccessDialog(result) {
            this.showDialogForm = false;
            switch (result.type) {
                case "kidSuccessDialog":
                    this.$refs.kidSuccessDialog.postFormSuccess(result.mobile);
                    break;
                case "successDialog":
                    this.$refs.successDialog.postFormSuccess();
                    break;
                default:
                    console.log("异常~");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.year-2020-double-11 {
    position: relative;
    background-color: #fff4d5;
    .content {
        width: px2rem(750);

        .banner {
            position: relative;
            width: 100%;
            height: px2rem(1391);

            img {
                width: 100%;
            }

            button {
                position: absolute;
                left: 50%;
                bottom: px2rem(38);
                transform: translateX(-50%);
                width: px2rem(631);
                height: px2rem(151);
                background: transparent;
                border: none;
            }
        }

        .banner,
        .children,
        .course-intro,
        .course-advance,
        .teacher-intro {
            font-size: 0;
            img {
                width: 100%;
            }
        }


        .lesson-form-box {
            height: 100%;
            .lesson-form {
                box-shadow: 0.05333rem 0.05333rem 0.29333rem 0 rgba(223, 0, 0, 0.11);
                padding-top: px2rem(60);
                box-sizing: border-box;
                height: 100%;
                border-radius: px2rem(32);
                .form-content {
                    text-align: center;

                    h2 {
                        display: inline-block;
                        width: px2rem(500);
                        height: px2rem(70);
                        background: url("https://web-data.zmlearn.com/image/9fPzSFFDcyBoZKmmCrNUNT/%E5%85%8D%E8%B4%B9%E9%A2%86%E5%8F%96200%E5%85%83%E6%80%9D%E7%BB%B4%E8%AF%BE.png") no-repeat center;
                        background-size: contain;
                        padding: 0px;
                    }

                    .form-item {
                        box-sizing: border-box;
                        margin: px2rem(24) auto px2rem(24);
                        width: px2rem(592);
                        height: px2rem(80);
                        position: relative;
                    }

                    .flex-item {
                        display: flex;
                        display: -webkit-flex;
                        margin-bottom: 0;
                        flex-flow: row nowrap;
                        justify-content: space-between;

                        .arrow {
                            display: none;
                        }
                    }

                    .grade,
                    .subject,
                    input {
                        height: px2rem(80);
                        background: #f2f2f2;
                        border: 1px solid #e0e0e0;
                        border-radius: px2rem(10);
                        text-indent: px2rem(20);
                        color: #222222;
                        font-size: px2rem(28);
                        line-height: px2rem(80);

                        &::-webkit-input-placeholder {
                            color: #a4a4a4;
                            font-size: px2rem(28);
                        }

                        &::-moz-placeholder {
                            color: #a4a4a4;
                            font-size: px2rem(28);
                        }
                    }

                    .area-code {
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: px2rem(96);
                        height: px2rem(80);
                        border-radius: px2rem(10);
                        background: transparent;
                        text-align: center;
                        line-height: px2rem(80);
                        display: inline-block;
                        color: #222222;
                        font-size: px2rem(28);
                        border: 1px solid transparent;
                    }

                    input.tel {
                        text-indent: px2rem(94);
                    }

                    .grade,
                    .subject {
                        text-indent: 0 !important;
                        padding-left: px2rem(20);
                        background-image: url("https://web-data.zmlearn.com/image/76uyXsFVHhgdV3TzNdhhTo/%E4%B8%8B%E4%B8%80%E6%AD%A5.png");
                        background-size: px2rem(21) px2rem(12);
                        background-position: 95% center;
                        background-repeat: no-repeat;
                    }
                }

                .form-protocol {
                    margin-top: px2rem(44);

                    .checkoutImg {
                        width: px2rem(28);
                        height: px2rem(28);
                        margin-right: px2rem(10);
                    }

                    .form-protocol-text {
                        font-size: px2rem(24);

                        .high-light {
                            color: #fb5058;
                        }
                    }
                }

                .zm-btn {
                    width: px2rem(428);
                    height: px2rem(90);
                    background: url("https://web-data.zmlearn.com/image/3GY7xbcAmUS9mGt7NbuaFg/Group.png") no-repeat center;
                    background-size: contain;
                    margin-bottom: px2rem(24);
                }

                .info {
                    margin: 0px;
                    width: 100%;
                    min-height: px2rem(32);
                    line-height: px2rem(32);
                    padding-bottom: px2rem(50);
                    color: #000;

                    span {
                        color: #000 !important;
                        font-size: px2rem(24);
                    }

                    p {
                        color: #aaa;
                        margin: px2rem(10) auto;
                    }
                }
            }

        }

        .dialog-form {
            position: fixed;
            z-index: 2;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.6);

            .lesson-form-content {
                position: absolute;
                width: px2rem(660);
                height: px2rem(760);
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);

                .dialog-form-close {
                    position: absolute;
                    display: block;
                    width: px2rem(75);
                    height: px2rem(75);
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: px2rem(-120);
                }
            }

        }
    }
    .get-course {
        font-size: 0;
        img {
            width: 100%;
        }
        &.fixed-bottom {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 1;
        }
    }
}
</style>
<style lang="scss">
    .year-2020-double-11 {
        .mask-box {
            border-radius: px2rem(32);
        }
        .form-protocol {
            .checkoutImg {
                width: px2rem(27);
                height: px2rem(27);
                margin-right: px2rem(20);
            }

            .form-protocol-text {
                .high-light {
                    color: #ff6e35;
                }
            }
        }
    }
</style>